// extracted by mini-css-extract-plugin
module.exports = {"telehealthAgreement":"styles_telehealthAgreement__2rEmj"};